module.exports = __webpack_public_path__ + "img/mama-shelter.cb54ee66.webp";